module.exports = __webpack_public_path__ + "img/128.29f00f79.jpg";